import mockData from './mockData.json';

/**
 * Mock API for Inventory Separation
 * These functions simulate API calls and return promises
 * Replace with actual react-query hooks when ready
 */

/**
 * Get overview and allocation data for a specific facility
 * @returns {Promise<Object>} Overview data including metrics and breakdowns
 */
export const getOverview = () =>
    new Promise((resolve) => {
        setTimeout(() => {
            // In real implementation, this would filter by facilityId
            resolve({
                success: true,
                data: mockData.overview,
            });
        }, 300); // Simulate network delay
    });

/**
 * Get projected issues data
 * @returns {Promise<Object>} Projected issues data
 */
export const getProjectedIssues = () =>
    new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                success: true,
                data: mockData.projectedIssues,
            });
        }, 300);
    });
